import { getDefaultReasoningEffortForModel } from '@/lib/pieveComposerSettings.js';
import getModelOptionById from '@/lib/model/getModelOptionById.js';
import { getPieveModelReasoningLevels } from '@shared/pieve/modelReasoning.js';

const REASONING_LABELS = Object.freeze({
  low: 'Low',
  medium: 'Medium',
  high: 'High',
  xhigh: 'Extra High'
});

const buildComposerModelState = ({ modelId, rawReasoningEffort } = {}) => {
  const modelOption = modelId ? getModelOptionById({ modelId, includeHidden: true }) : null;
  const reasoningLevels = getPieveModelReasoningLevels(modelId);
  const reasoningEffort = reasoningLevels.includes(rawReasoningEffort) ? rawReasoningEffort : getDefaultReasoningEffortForModel(modelId);
  const reasoningMatch = REASONING_LABELS[reasoningEffort];

  return {
    modelId,
    reasoningEffort,
    label: modelOption?.pickerLabel || modelId || 'Model',
    reasoningLabel: reasoningMatch || ''
  };
};

export default buildComposerModelState;
